import React from 'react';
import { Icon } from 'antd';
import { useNavigate } from "react-router-dom";
import SummaryTooltip from './SummaryTooltip';
import TrendIcon from './TrendIcon';

type Props = {
    totalBacklinks: number[];
    websiteGuid: string;
};

export default function BacklinksSummary({ totalBacklinks, websiteGuid }: Props) {
    const navigate = useNavigate();
    const oldestValue = totalBacklinks[0];
    const currentValue = totalBacklinks[totalBacklinks.length - 1];

    const handleViewReport = () => {
        navigate(`/backlinks?w_guid=${websiteGuid}`);
    };

    return (
        <div className="dashboard-summary-section">
            <div className="container">
                <div className="dashboard-summary-section-title">
                    <span>Backlinks</span>
                    <SummaryTooltip
                        resourceType="backlinks"
                        currentValue={currentValue}
                        comparedTo={oldestValue}
                    />
                </div>
                <div className="dashboard-summary-section-result">
                    {totalBacklinks.length > 0 ? (
                        <>
                            <TrendIcon
                                resourceType="backlinks"
                                currentValue={currentValue}
                                comparedTo={oldestValue}
                            />
                            <span>{currentValue.toLocaleString()}</span>
                        </>
                    ) : (
                        <span>No data</span>
                    )}
                </div>
            </div>

            <div
                className="view-report-btn"
                onClick={handleViewReport}
            >
                <span>View report</span>
                <Icon type="right" />
            </div>
        </div>
    );
}
